export default defineNuxtPlugin(() => {
  if (process.client) {
    document.cookie = 'laravel_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    document.cookie = '_web_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

    const adminSession = useCookie('_admin_session')
    if (adminSession.value) {
      document.cookie = 'laravel_session=' + adminSession.value + '; path=/;'
    }
  }
})
